import {appendResponseHeader} from 'h3';

let refreshPromise = null;

function getSetCookieHeaders(headers) {
  const getSetCookie = headers.getSetCookie?.();
  if (getSetCookie?.length) return getSetCookie;

  const setCookie = headers.get('set-cookie');
  return setCookie ? setCookie.split(/,(?=\s*[^;,]+=)/) : [];
}

async function refreshToken() {
  // On SSR, $fetch does not forward the browser's Cookie header automatically —
  // we must pass it explicitly so the server endpoint can read the refresh_token cookie.
  // On the client, credentials: 'include' ensures the browser attaches httpOnly cookies.
  if (process.server) {
    const headers = useRequestHeaders(['cookie', 'host', 'x-forwarded-host', 'x-forwarded-proto']);
    const event = useRequestEvent();
    const {authState} = useAuthCookie();

    const response = await $fetch.raw('/app/api/auth/refresh', {
      method: 'POST',
      headers
    });

    const setCookieHeaders = getSetCookieHeaders(response.headers);
    for (const header of setCookieHeaders) {
      appendResponseHeader(event, 'set-cookie', header);
    }

    authState.value = response._data.user_info;
    return;
  }

  // The browser applies the response's Set-Cookie header directly, and every subsequent
  // client-side read goes straight to the cookie (see useAuthCookie().currentUserInfo) —
  // no in-memory mirror needed here.
  await $fetch('/app/api/auth/refresh', {method: 'POST', credentials: 'include'});
}

function refreshOnce() {
  if (!refreshPromise) {
    refreshPromise = refreshToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}

export function useTokenRefresh() {
  return {refreshToken, refreshOnce};
}
